export default __webpack_public_path__ + "static/color-analysis-jewelry-f87c8c44b19932347d209745c2edc0a1.jpg";